import React, { useState } from 'react';
import styles from './Footer.module.css';

const Footer = () => {
  const [showScroll, setShowScroll] = useState(false);

  const checkScrollTop = () => {
    if (!showScroll && window.pageYOffset > 400) {
      setShowScroll(true);
    } else if (showScroll && window.pageYOffset <= 400) {
      setShowScroll(false);
    }
  };

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  window.addEventListener('scroll', checkScrollTop);

  const currentYear = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className="container">
        <div className={styles.footerContent}>
          <div className={styles.footerLogo}>
            <i className="fa fa-qrcode"></i>
            <span>REGIONCHECK.RU</span>
          </div>
          
          <div className={styles.footerInfo}>
            <p>Официальные гостиничные чеки с QR-кодом по всей России</p>
            <p>Телефон: <a href="tel:+79874817932">+7 (987) 481-79-32</a></p>
            <p>Email: <a href="mailto:mirat7932@mail.ru">mirat7932@mail.ru</a></p>
          </div>
          
          <div className={styles.footerLegal}>
            <p>© {currentYear} RegionCheck. Все права защищены.</p>
            <p>Предоставление официальных документов для отчётности</p>
          </div>
        </div>
      </div>
      
      {showScroll && (
        <button onClick={scrollTop} className={styles.scrollToTop}>
          <i className="fa fa-chevron-up"></i>
        </button>
      )}
    </footer>
  );
};

export default Footer;